module.exports = __webpack_public_path__ + "img/user.627c6af7.svg";